import { SEditableColumn } from './EditableColumn.styles';
import { EditableColumnProps } from './EditableColumn.types';

export const EditableColumn = ({ ...props }: EditableColumnProps) => {
  return <SEditableColumn {...props} />;
};
